import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 100);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  const isActive = (path: string) => location.pathname === path;

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 sm:py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center">
          <img
            src="https://storage.readdy-site.link/project_files/2187da0a-21b3-4ece-aeaa-a1feb7ccdc4d/f1e9c180-6709-424c-930d-559cebaf760e_logo-eht.jpg?v=f6a85c94804879a800fb58411e74ca9f"
            alt="EHT AUTOMOBILE Logo"
            className="h-10 sm:h-12 w-auto object-contain"
          />
        </Link>

        <div className="hidden md:flex items-center gap-8">
          <Link
            to="/"
            className={`text-sm font-medium transition-colors whitespace-nowrap ${
              isActive('/') 
                ? 'text-secondary' 
                : isScrolled ? 'text-dark hover:text-secondary' : 'text-white hover:text-secondary'
            }`}
          >
            Accueil
          </Link>
          <Link
            to="/horaires"
            className={`text-sm font-medium transition-colors whitespace-nowrap ${
              isActive('/horaires') 
                ? 'text-secondary' 
                : isScrolled ? 'text-dark hover:text-secondary' : 'text-white hover:text-secondary'
            }`}
          >
            Horaires &amp; Accès
          </Link>
          <Link
            to="/devis"
            className={`text-sm font-medium transition-colors whitespace-nowrap ${
              isActive('/devis') 
                ? 'text-secondary' 
                : isScrolled ? 'text-dark hover:text-secondary' : 'text-white hover:text-secondary'
            }`}
          >
            Demande de Devis
          </Link>
          <Link
            to="/rendez-vous"
            className={`text-sm font-medium transition-colors whitespace-nowrap ${
              isActive('/rendez-vous') 
                ? 'text-secondary' 
                : isScrolled ? 'text-dark hover:text-secondary' : 'text-white hover:text-secondary'
            }`}
          >
            Rendez-vous
          </Link>
        </div>

        <div className="flex items-center gap-2 sm:gap-3">
          <div className="hidden lg:flex items-center gap-6">
            <a href="tel:+33661515174" className="flex items-center gap-2 text-dark hover:text-secondary transition-colors cursor-pointer">
              <i className="ri-phone-line text-xl"></i>
              <span className="font-medium">06 61 51 51 74</span>
            </a>
          </div>

          <Link
            to="/admin"
            title="Espace Administration"
            className={`hidden md:flex w-9 h-9 items-center justify-center rounded-lg transition-colors cursor-pointer ${
              isScrolled ? 'text-gray-400 hover:text-dark hover:bg-gray-100' : 'text-white/50 hover:text-white hover:bg-white/10'
            }`}
          >
            <i className="ri-shield-keyhole-line text-lg"></i>
          </Link>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors cursor-pointer ${
              isScrolled ? 'text-dark' : 'text-white'
            }`}
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-200 shadow-lg">
          <div className="px-4 py-4 space-y-3">
            <Link
              to="/"
              className={`block px-4 py-3 rounded-lg text-sm font-medium transition-colors cursor-pointer ${
                isActive('/') ? 'bg-secondary text-white' : 'text-dark hover:bg-gray-100'
              }`}
            >
              <i className="ri-home-line mr-2"></i>
              Accueil
            </Link>
            <Link
              to="/horaires"
              className={`block px-4 py-3 rounded-lg text-sm font-medium transition-colors cursor-pointer ${
                isActive('/horaires') ? 'bg-secondary text-white' : 'text-dark hover:bg-gray-100'
              }`}
            >
              <i className="ri-time-line mr-2"></i>
              Horaires &amp; Accès
            </Link>
            <Link
              to="/devis"
              className={`block px-4 py-3 rounded-lg text-sm font-medium transition-colors cursor-pointer ${
                isActive('/devis') ? 'bg-secondary text-white' : 'text-dark hover:bg-gray-100'
              }`}
            >
              <i className="ri-file-text-line mr-2"></i>
              Demande de Devis
            </Link>
            <Link
              to="/rendez-vous"
              className={`block px-4 py-3 rounded-lg text-sm font-medium transition-colors cursor-pointer ${
                isActive('/rendez-vous') ? 'bg-secondary text-white' : 'text-dark hover:bg-gray-100'
              }`}
            >
              <i className="ri-calendar-line mr-2"></i>
              Rendez-vous
            </Link>

            <div className="border-t border-gray-100 pt-3 mt-1">
              <Link
                to="/admin"
                className={`block px-4 py-3 rounded-lg text-sm font-medium transition-colors cursor-pointer ${
                  isActive('/admin') || isActive('/admin/dashboard') ? 'bg-gray-900 text-white' : 'text-gray-400 hover:bg-gray-100 hover:text-dark'
                }`}
              >
                <i className="ri-shield-keyhole-line mr-2"></i>
                Espace Administration
              </Link>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}
